import React, { useState, lazy, Suspense } from "react";
import Constants from "../constants/Constants";
import PPVItem from "./PPVItem";
import DMMedia from "./DMMedia";
import Linkify from "react-linkify";
const RequestPayment = lazy(() => import("./RequestPayment"));
const ChatBubble = ({
  direction,
  isLast,
  msg,
  siteURL,
  setImages,
  modelName,
  biller,
  custom_done,
  setSlideIndex,
  request_type,
  hasError,
  index,
  token,
  fullLinks,
  payment_id,
  special,
  requestPrice,
  ppvid,
  mediaLength,
  mediaType,
  paid,
  readable,
  dispatch,
  udp,
  file,
  mediaLinks,
  price,
}) => {
  const [showWhenSent, setShowWhenSent] = useState(false);
  return (
    <div
      className={special ? "chatBubbleContainer tipped" : "chatBubbleContainer"}
    >
      <div
        className={direction === "from" ? "fromMe" : "fromFriend"}
        style={isLast ? { paddingBottom: 0 } : null}
        onClick={() => {
          if (direction === "from") {
            setShowWhenSent((prev) => !prev);
          }
        }}
      >
        {direction !== "from" ? (
          <div
            className="dmAvatar bot"
            onClick={() => setShowWhenSent((prev) => !prev)}
          >
            <img
              src={`${Constants.CDN}images/sites/${siteURL}.jpg`}
              alt={modelName}
            />
          </div>
        ) : null}
        <div
          className={
            hasError
              ? "chatBubble error"
              : mediaType === "wav"
              ? "chatBubble audioChat"
              : "chatBubble"
          }
        >
          {requestPrice && (
            <Suspense fallback={<div>Loading...</div>}>
              <RequestPayment
                price={parseInt(requestPrice)}
                msg={msg}
                paid={paid}
                payment_id={payment_id}
                custom_done={custom_done}
                request_type={request_type}
                token={token}
              />
            </Suspense>
          )}
          {ppvid ? (
            price !== 0 ? (
              <PPVItem
                ppvid={ppvid}
                file={file}
                price={price}
                biller={biller}
                dispatch={dispatch}
                udp={udp}
              />
            ) : (
              <DMMedia
                mediaLength={mediaLength}
                mediaLinks={mediaLinks}
                fullLinks={fullLinks}
                setImages={setImages}
                setSlideIndex={setSlideIndex}
                file={file}
                mediaType={mediaType}
              />
            )
          ) : null}
          {special ? <span className="special">{special}</span> : null}
          {!requestPrice && mediaType !== "wav" ? (
            direction === "to" ? (
              <Linkify>{msg}</Linkify>
            ) : (
              msg
            )
          ) : null}
        </div>
        {hasError ? <div className="chatErrorMsg">{hasError}</div> : null}
      </div>
      {showWhenSent ? (
        <div
          className={direction === "from" ? "showDateSent" : "showDateSent alt"}
        >
          {readable}
        </div>
      ) : null}
    </div>
  );
};

export default ChatBubble;
